// extracted by mini-css-extract-plugin
export default {"formAdd":"desk_formAdd__Dk10X","formTitle":"desk_formTitle__WcBoA","loginForm":"desk_loginForm__yceg4","loginBack":"desk_loginBack__rpatA"};